import { render, staticRenderFns } from "./phbDetail.vue?vue&type=template&id=ab8b0f78"
import script from "./phbDetail.vue?vue&type=script&lang=js"
export * from "./phbDetail.vue?vue&type=script&lang=js"
import style0 from "./phbDetail.vue?vue&type=style&index=0&id=ab8b0f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports